<template>
<div class="sample-order-message">
    <pt-sub-title title="订单信息"></pt-sub-title>
    <table class="sample-order-message-table">
        <tr>
            <td>订单内容：</td>
            <td>{{goods.name}}</td>
        </tr>
        <tr>
            <td>用户：</td>
            <td>{{orderDetail.mallUserNickName}}</td>
        </tr>
        <tr>
            <td>收货信息：</td>
            <td>
                <span>{{shippingAddress.contactName}}</span>
                <span>{{shippingAddress.phone}}</span>
                <span v-if="shippingAddress.provinceName||+shippingAddress.cityName||shippingAddress.districtName||shippingAddress.postAddress">
                    {{shippingAddress.provinceName+shippingAddress.cityName+shippingAddress.districtName+shippingAddress.postAddress}}
                    </span>
            </td>
        </tr>
        <tr>
            <td>备注：</td>
            <td>{{orderDetail.remark}}</td>
        </tr>
    </table>
</div>
</template>
<script>
export default {
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    goods () {
      return (this.orderDetail && this.orderDetail.goods && this.orderDetail.goods[0]) || {}
    },
    shippingAddress () {
      return (this.orderDetail && this.orderDetail.shippingAddress) || {}
    }
  }
}
</script>
<style lang="less">
@import '~less/var';
.sample-order-message{
    .sample-order-message-table{
        padding: 0 20px;
        td{
            padding-bottom: 10px;
            font-size: 15px;
            &:first-child{
                 display: flex;
                justify-content: flex-end;
                margin-right: 10px;
                white-space:nowrap;
            };
            &:last-child{
                color: #5B5B5B;
                span{
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>
